// Module
var code = "<svg viewBox=\"0 0 5 8\" width=\"5\" height=\"8\" xmlns=\"http://www.w3.org/2000/svg\" stroke=\"none\"><path d=\"M.935 8l4.059-4L.935.001.006.903 3.15 4 .006 7.098z\"/></svg> ";
// Exports
module.exports = code;